module.exports = __webpack_public_path__ + "assets/logo_vertical.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/logo_vertical.svg
 ** module id = 227
 ** module chunks = 1
 **/